<div class="section-list card">
    <div class="card-header">
        <nav class="navbar navbar-expand-sm navbar-light navbar-section-header justify-content-between section-header">
            <span class="navbar-brand mb-0 h1"><i class="fas fa-list"></i> Reports</span><span class="badge badge-primary">{{listFiltered.length}}</span>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <div class="ml-auto d-flex justify-content-end">
                   
                    <ul class="nav navbar-nav ml-auto">
                        <li class="nav-item">
                            <div class="search-container">
                                <i class="fa fa-search search-icon"></i>
                                <input class="form-control form-control-sm search-box" type="text" (input)="frtable.filterGlobal($event.target.value, 'contains')"
                                    placeholder="Filter" >                                    
                            </div>
                        </li>                      
<!--                         <li  class="nav-item" *permusr="controlEnum.BTN_SITE_NEW" class="nav navbar-nav ml-auto">
                            <a class="nav-link" role="button" (click)="newSite();false">
                                <i class="far fa-plus-square"></i> New Site
                            </a>
                        </li> -->

                        <li class="nav-item">
<!--                             <a class="nav-link" role="button" (click)="refresh();false">
                                <i class="fas fa-sync"></i>
                            </a> -->
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    </div>
    <div class="card-body">

        <mat-progress-bar mode="indeterminate" *ngIf="loadinglist"></mat-progress-bar>
        <app-frms-messagebar *ngIf="alertmessage" [alertmessage]="alertmessage"></app-frms-messagebar>
        <div class="app-table ">
            <p-table #frtable [value]="listFiltered" sortMode="multiple" [globalFilterFields]="['name','company.name','info.zone','info.countryFull2']">
                <ng-template pTemplate="header">
                    <tr>
                        <th [pSortableColumn]="'name'">Report
                            <p-sortIcon [field]="'name'"></p-sortIcon>
                        </th>
                        <th [pSortableColumn]="'type'">Type
                            <p-sortIcon [field]="'type'"></p-sortIcon>
                        </th>                        
                        <th [pSortableColumn]="'updating_date'">Last update
                            <p-sortIcon [field]="'updating_date'"></p-sortIcon>
                        </th>
                        <th>                            
                        </th>                        
                        <th>

                        </th>

                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-row>
                    <tr >
                        <td>{{row.name}}</td>
                        <td>{{row.type}} <i class="{{row.fullName|filetypeico}}"></i></td>
                        <td>{{row.updating_date | date:'dd-MM-yyyy HH:mm' }}</td>
                        <td>
                            
                        </td>
                        <td (click)="$event.stopPropagation()">
                            
                                <div class="td-actions text-right"> 
                                    <a target="_blank" href="{{downloadlink(row)}}">
                                <i class="fas fa-file-download"></i> Download</a>
                                </div>
<!--                                                         
                                <button type="button" class="btn btn-sm btn-outline-secondary"
                                    [matMenuTriggerFor]="menu">
                                    <i class="fas fa-ellipsis-v"></i>
                                </button>
                                <mat-menu #menu="matMenu" class="">
                                      <div mat-menu-item *permusr="{id:controlEnum.BTN_SITE_DELETE, authFunction:acl_btn_bysite(controlEnum.BTN_SITE_DELETE,row)}">
                                        <a class="dropdown-item text-danger" [routerLink]=""
                                            (click)="openDialogDeleteSite(row)">
                                            <i class="far fa-trash-alt"></i> Delete
                                        </a>
                                    </div>
                                </mat-menu>
                            </div> -->
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>